
import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/views/Home.vue';

Vue.use(VueRouter);

const routes = [

  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/khatmat/create',
    name: 'CreateKhatma',
    component: () => import('@/views/CreateKhatma.vue')
  },
  {
    path: '/khatmat/result',
    name: 'KhatmaResult',
    component: () => import('@/views/KhatmaResult.vue')
  },
  {
    path: '/khatmat/:id',
    name: 'Khatma',
    component: () => import('@/views/Khatma.vue')
  }

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
